import VisitaGastroenterologicaEdit from "./components/VisitaGastroenterologicaEdit.vue"
import VisitaGastroenterologicaView from "./components/VisitaGastroenterologicaView.vue"
import VisitaGastroenterologicaList from "./components/VisitaGastroenterologicaList.vue"

export default{
    VisitaGastroenterologicaEdit,
    VisitaGastroenterologicaView,
    VisitaGastroenterologicaList
}